import React from 'react';
import { PRICE_VALUE } from '../../data/content';
type CtaButtonProps = {
  children?: React.ReactNode;
  size?: 'sm' | 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
};
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}
const sizing: Record<NonNullable<CtaButtonProps['size']>, string> = {
  sm: 'px-5 py-3 text-[13px]',
  lg: 'px-8 py-4 text-sm md:text-base',
  xl: 'px-8 py-5 text-[15px] md:px-10 md:text-lg'
};
export function CtaButton({
  children = 'Agendar la videollamada',
  size = 'lg',
  fullWidth = false,
  href = '#oferta'
}: CtaButtonProps) {
  const handleClick = () => {
    if (!href.startsWith('#') && window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        value: PRICE_VALUE,
        currency: 'ARS'
      });
    }
  };
  return <a href={href} onClick={handleClick} {...href.startsWith('#') ? {} : {
    target: '_blank',
    rel: 'noopener noreferrer'
  }} className={`inline-flex items-center justify-center whitespace-nowrap rounded-full bg-[#15803d] text-center font-extrabold uppercase tracking-wide text-white shadow-cta transition-[background-color,transform] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#166534] active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-green ${sizing[size]} ${fullWidth ? 'w-full' : ''}`} data-id="element-176" data-mp="136tps5jxdtdt">
      {children}
    </a>;
}